import React from 'react';
import classNames from 'classnames/bind';
import styles from './feedbackTitle.module.scss';

const cx = classNames.bind(styles);

export const FeedBackTitle = () => {
  return (
    <div className={cx('titleArea')}>
      <strong className={cx('title')}>
        <span className={cx('emphasis')}>역량검사</span> 리포트가 도움이 되셨나요?
      </strong>
      <span className={cx('subTitle')}>피드백을 남겨주시면 결과표 개선에 큰 도움이 됩니다.</span>
    </div>
  );
};

export const FeedBackEndTitle = () => {
  return (
    <div className={cx('titleArea')}>
      <strong className={cx('title')}>좋은 의견 주셔서 감사합니다.</strong>
      <span className={cx('subTitle')}>남겨주신 피드백은 소중하게 여기겠습니다.</span>
    </div>
  );
};
